var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showform)?_c('dynamic-form',{attrs:{"params":_vm.params,"formtype":"flowform"},on:{"toggle-form":_vm.toggleForm}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }